import { render } from "./LearningCatalog.vue?vue&type=template&id=ca5e04b8&scoped=true"
import script from "./LearningCatalog.vue?vue&type=script&lang=js"
export * from "./LearningCatalog.vue?vue&type=script&lang=js"

import "./LearningCatalog.vue?vue&type=style&index=0&id=ca5e04b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5e04b8"]])

export default __exports__